const REQUEST_LINES = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_LINES = (state, { body }) => {
  state.Lines = body;
  state.status = "success";
};

const FAILURE_REQUEST_LINES = state => {
  state.status = "failure";
};

const REQUEST_DELETE_LINE = state => {
  state.statusDelete = "fetching";
};

const SUCCESS_REQUEST_DELETE_LINE = state => {
  state.statusDelete = "success";
};

const FAILURE_REQUEST_DELETE_LINE = state => {
  state.statusDelete = "failure";
};

const REQUEST_UPDATE_LINE = (state) => {
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_LINE = state => {
  state.statusUpdate = "success";
};

const FAILURE_REQUEST_UPDATE_LINE = state => {
  state.statusUpdate = "failure";
};

const REQUEST_CREATE_LINE = state => {
  state.statusCreate = "fetching";
};

const SUCCESS_REQUEST_CREATE_LINE = (state, { body }) => {
  state.Line = body;
  state.statusCreate = "success";
};

const FAILURE_REQUEST_CREATE_LINE = state => {
  
  state.statusCreate = "failure";
};


export default {
  REQUEST_LINES,
  SUCCESS_REQUEST_LINES,
  FAILURE_REQUEST_LINES,
  REQUEST_CREATE_LINE,
  SUCCESS_REQUEST_CREATE_LINE,
  FAILURE_REQUEST_CREATE_LINE,
  REQUEST_DELETE_LINE,
  SUCCESS_REQUEST_DELETE_LINE,
  FAILURE_REQUEST_DELETE_LINE,
  REQUEST_UPDATE_LINE,
  SUCCESS_REQUEST_UPDATE_LINE,
  FAILURE_REQUEST_UPDATE_LINE,

};
